import { useMutation } from "@tanstack/react-query";
import customerService from "..";
import { CreateUsers } from "../type";

function useCreateCustomerBulk() {
  return useMutation({
    mutationFn: (command: CreateUsers) => {
      return customerService.addCustomersBulk(command);
    },
  });
}

export default useCreateCustomerBulk;
